export default __webpack_public_path__ + "static/media/grid_ppt.30918003.svg";